export enum FormInputWithDroppanelVariant {
    Default = 'sh-form-multiselect',
    Ghost = 'sh-form-multiselect--ghost'
}
